/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCall = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.341 15.504c.596.559 1.215 1.07 1.848 1.525l3.72-3.721 6.304.9v5.525l-.293.293c-2.193 2.193-6.264 1.684-10.224-.91a20.315 20.315 0 0 1-3.21-2.626 20.315 20.315 0 0 1-2.626-3.21C2.265 9.32 1.757 5.248 3.95 3.055l.293-.293h5.524l.9 6.303-3.72 3.72a18.524 18.524 0 0 0 1.952 2.29zm3.585 2.616c2.615 1.412 4.997 1.657 6.287.739v-2.916l-3.596-.514zm-7.07-7.07 2.69-2.692-.514-3.596H5.117c-.918 1.29-.674 3.672.738 6.287z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCall as Call };
